export var name = 'account';
export var COOKIE_CONSENT_NAME = 'betcheck';
